import React, { useState } from 'react';
import {
    Box,
    Container,
    Paper,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { usePermission } from '../../hooks/usePermission';
import RelationshipForm from '../../Components/Relationships/RelationshipForm';
import RelationshipTable from '../../Components/Relationships/RelationshipTable';
import { CreateRelationshipsPermission } from '../../constants/permissions';

const Relationships = () => {
    const { data: canCreateRelationship } = usePermission({
        permissionName: CreateRelationshipsPermission
    });

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({
            name: '',
            description: '',
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Container maxWidth="xl">
            <Box sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="h4" component="h1">
                        Relationships
                    </Typography>
                    {canCreateRelationship && (
                        <button
                            className='bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2'
                            onClick={handleClickOpen}
                        >
                            <AddIcon />
                            Add New Relationship
                        </button>
                    )}
                </Box>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <RelationshipTable />
                </Paper>

                <RelationshipForm
                    open={open}
                    onClose={handleClose}
                    formData={formData}
                    onInputChange={handleInputChange}
                />
            </Box>
        </Container>
    );
};

export default Relationships; 